import createReducer from '../createReducer';
import {TAccountEventsState} from './accountEvents.type';

export const initialStateAccountEvents: TAccountEventsState = {
    events: [],
    counts: null,
    areCountsFiltered: false,
    hasMore: false,
    domain: ''
};

const reducer = createReducer('accountEvents', initialStateAccountEvents);

export default reducer;
